import {z} from "zod";

export const MIN_PAYKU_DEPOSIT = 5000;

export const paykuDepositSchema = z.object({
  amount: z.coerce
    .number({message: "Monto inválido"})
    .min(MIN_PAYKU_DEPOSIT, `El monto mínimo es ${MIN_PAYKU_DEPOSIT}`),
  paymentMethod: z.number({message: "Selecciona un método de pago"}).int().positive("Selecciona un método de pago"),
});
